import type { FaireProductEntity } from "../../entity_types/product";

export const p_wkbxajunjm: FaireProductEntity = {
  token: "p_wkbxajunjm",
  type: "product",
  name: "Wild Yam Hormone Cream™",
  brandToken: "b_nay2x5mkxs",
  brandName: "Genesis Holistic Health",
  imageUrl:
    "https://cdn.faire.com/fastly/dd73663c8cbe0da8cc64226b55180e75116ba44a082a87a87dd17ce2cbefa779.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c59ad96ff5ba4199f0c4b3002890388de14ae2e42641b7ec11e101d542e1c936.png",
    "https://cdn.faire.com/fastly/460c48bdded116ab540d840487c0a38c036d5a1a222b06381110016ad52a89ff.png",
    "https://cdn.faire.com/fastly/fcf58d2f10cad170f7fa7e08d4d8d2e4a2151c229f3a65248217f62cea592bb8.png",
    "https://cdn.faire.com/fastly/8a3c237a994edcb0ecb97a37d18235ef34b5cd84acd35c47f1b8a78c19f27800.png",
    "https://cdn.faire.com/fastly/95dbc1b4f8a73fed555a1fbf24b2dfa20313362a2d1d7f71ab32b39a705a7970.png",
    "https://cdn.faire.com/fastly/1cf7f1029dea931b627b819bc2627bf9d8780e50b0c539c9ea92214d675f95a4.png",
    "https://cdn.faire.com/fastly/5be42384686885696703b1c1dae8498748b60c1475335698f711685d31d24dc6.png",
  ],
  priceDollars: 11.99,
  description:
    "\nORGANIC WILD YAM CREAM - SUPPORT THE BODY AND BRING IT BACK INTO ORIGINAL RHYTHM WITH OUR WILD YAM HORMONE SUPPORT CREAM. MADE WITH ORGANIC\nHERBS AND OILS, OUR HORMONAL BALANCING CREAM IS PERFECT FOR THOSE LOOKING FOR A NATURAL ALTERNATIVE.\n\n*DO NOT USE IF YOU ARE PREGNANT, BREASTFEEDING, OR IF YOU HAVE SEIZURE DISORDERS.\n\nMANY ADULTS AND TEENS SUFFER FROM A FORM OF HORMONAL IMBALANCE. SOMETIMES WE JUST NEED A LITTLE BOOST IN THE RIGHT DIRECTION.\n",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:02.276Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
